import "./TogglePieChartKPI.css";

import { ReactNode } from "react";

import { ToggleTabsList } from "../../../../models";
import { Card, PieChart, PieChartCenterTextFont, PieChartColors, ToggleTabs } from "../../..";

export interface TogglePieChartKPIProps {
  data: { [key: string]: number };
  title: string;
  centerTextSuffix?: string;
  size?: number;
  colours?: PieChartColors;
  noDataMessage?: string;
  tooltip?: ReactNode;
  showValues?: boolean;
  isGradient?: boolean;
  centerTextFont?: PieChartCenterTextFont;
  chartColorsOverride?: string[][];
  toggleTabsList: ToggleTabsList;
  currentTab?: string;
  onChange: (value: string) => void;
}

export const TogglePieChartKPI = ({
  data,
  title,
  centerTextSuffix,
  size = 120,
  colours = "default",
  noDataMessage,
  tooltip,
  showValues = true,
  isGradient = true,
  centerTextFont,
  chartColorsOverride,
  toggleTabsList,
  currentTab,
  onChange,
}: TogglePieChartKPIProps): JSX.Element => {
  return (
    <Card height="100%" corners="rounded">
      <div className="TogglePieChartKPIContainer">
        <div className="TogglePieChartKPIHeader">
          <div>
            <p className="body01">{title}</p>
            <div>{tooltip}</div>
          </div>
          <ToggleTabs toggleTabsList={toggleTabsList} currentTab={currentTab} onChange={onChange} size="small" />
        </div>
        <div className="TogglePieChartKPIContent">
          <PieChart
            key={currentTab}
            size={size}
            data={data}
            centerTextSuffix={centerTextSuffix}
            noDataMessage={noDataMessage}
            colors={colours}
            showValues={showValues}
            isGradient={isGradient}
            centerTextFont={centerTextFont}
            chartColorsOverride={chartColorsOverride}
          />
        </div>
      </div>
    </Card>
  );
};
